import { presetsService } from '@saucelabs/sl-util-axios';

import { FetchPresetsResponse } from './records';
import constants from './constants';
import { components } from '../../../types/presetsApi.d';

type ServerNewPresetSchema = components['schemas']['NewPresetPayload']
export type ServerNewPreset = Required<ServerNewPresetSchema>;

const fetchPresets = (): AsyncResponse<FetchPresetsResponse> => (
  presetsService.get<FetchPresetsResponse>('/v1/presets/', {
    // hard-coded for now to make sure we request max. 10 recent presets
    // might be configurable in the future
    params: {
      kind: constants.PRESET_KINDS.RECENT,
      page: 1,
      per_page: constants.MAX_RECENTS_ITEMS,
    },
  })
);

const postRecentPreset = (payload: ServerNewPreset): AsyncResponse<unknown> => (
  presetsService.post(`/v1/presets/${constants.PRESET_KINDS.RECENT}`, payload)
);

export default {
  fetchPresets,
  postRecentPreset,
};
